/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import cx from 'classnames';
import '@itwin/itwinui-css/css/utils.css';
const getSizeValue = (size) => {
    switch (size) {
        case 'small':
            return 's';
        case 'medium':
            return 'm';
        case 'large':
            return 'l';
        default:
            return size;
    }
};
/**
 * A utility component to provide size and fill to svgs.
 * Works well with svgs from `@itwin/itwinui-icons-react`.
 *
 * @example
 * <Icon>
 *   <SvgPlaceholder />
 * </Icon>
 *
 * @example
 * <Icon fill='negative'>
 *   <SvgStatusError />
 * </Icon>
 */
export const Icon = React.forwardRef((props, ref) => {
    const { size = 'medium', fill = 'default', className, ...rest } = props;
    return (React.createElement("span", { className: cx('iui-svg-icon', className), "data-iui-icon-size": getSizeValue(size), "data-iui-icon-color": fill, ref: ref, ...rest }));
});
export default Icon;
